<template>
  <div class="container-private-call-income" :style="`paddingTop:${topBarHeight}px`">
    <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb">
      <template #left>
        <img class="left-nav" src="@/assets/packageAssets/common/arrow02.webp" alt="" @click-left="closeWeb" />
      </template>
    </van-nav-bar>

    <div class="main">
      <div class="title">
        <img class="title_ar" v-if="$i18n.locale == 'ar'" src="./images/title_ar.webp" alt="" />
        <img class="title_ar" v-else-if="$i18n.locale == 'id'" src="./images/title_id.webp" alt="" />
        <img class="title_en" v-else src="./images/title.webp" alt="" />
      </div>

      <div class="content">
        <img v-if="$i18n.locale == 'ar'" src="./images/content_bg_ar.webp" alt="" />
        <img v-else-if="$i18n.locale == 'id'" src="./images/content_bg_id.webp" alt="" />
        <img v-else src="./images/content_bg.webp" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
// 主播补贴活动
export default {
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.container-private-call-income {
  width: 100%;
  min-height: 100vh;
  background: url('~./images/page_bg.webp') no-repeat;
  background-size: 100% 100%;
  .main {
    padding: 20px 20px 30px;
  }
  .title {
    width: 100%;
    text-align: center;
  }
  .title_ar {
    height: 122px;
  }
  .title_en {
    height: 141px;
  }
  .content {
    width: 100%;
    margin: 20px auto 0;
    color: #592c02;
    > img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
